export default "__VITE_ASSET__KHMz_XMs__"